import { render } from "./ExpertiseBoxesHumanCentric.vue?vue&type=template&id=bc4dec12"
import script from "./ExpertiseBoxesHumanCentric.vue?vue&type=script&lang=js"
export * from "./ExpertiseBoxesHumanCentric.vue?vue&type=script&lang=js"

import "./ExpertiseBoxesHumanCentric.vue?vue&type=style&index=0&id=bc4dec12&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__